<template>
  <div c_name="HomeMobile">
    <Swiper :datas="swiperData" :opts="''" @events="swiperEvents" />
    <div class="home_types_div">
      <ul class="home_type_ul">
        <li v-for="(type, index) in allData" :key="index"
          class="ul_li_menu" :class="{ active: index == nowType }"
          :style="{width: (100 / allData.length) + '%'}"
          @click="onClickType(index)">
          {{type.title}}
        </li>
      </ul>
    </div>
    <div class="home_lists_div">
      <ul v-if="allData[nowType].type != 'list'">
        <li v-for="(list, index) in allData[nowType].list" :key="index"
          class="ul_li_menu_list" :class="{ active: index == nowList }"
          @click="onClickList(index)">
          {{list.title}}
        </li>
      </ul>
      <div style="clear: left;" />
    </div>
    <div class="home_games_list">
      <template v-for="(item, index) in games">
        <GameListItem :datas="item" :opts="''" @events="gameEvents" :key="index"/>
      </template>
      <div />
    </div>

    <div class="page_space home_huodong" :style="huodongBgStyle">
      <div class="huodong_title">
        <img src="@/assets/huodong_dot.png" alt="">
        新闻资讯
      </div>
      <div class="huodong_item" v-for="(item, index) in news" :key="index">
        <img src="@/assets/huodong_dot2.png" alt="">
        <a :href="item.router">{{item.title}}</a>
      </div>
    </div>

    <div class="page_space home_huodong" :style="huodongBgStyle">
      <div class="huodong_title">
        <img src="@/assets/huodong_dot.png" alt="">
        精彩活动
      </div>
      <div class="huodong_item" v-for="(item, index) in huodongs" :key="index">
        <img src="@/assets/huodong_dot2.png" alt="">
        <router-link :to="item.router">{{item.title}}</router-link>
      </div>
    </div>
    <img class="btm_16" src="/static/img/16p.png" alt="">
  </div>
</template>
<script>
// @ is an alias to /src
import Swiper from '@/components/common/Swiper.vue'
import GameListItem from '@/components/GameListItem.vue'
import tools from '@/tools/tools'

export default {
  name: 'HomeMobile',
  components: {
    Swiper,
    GameListItem
  },
  data: () => {
    return {
      nowGame: {},
      nowType: 0,
      nowList: 0
    }
  },
  created () {
    this.nowGame = this.games[0]
  },
  methods: {
    // 轮播事件返回
    swiperEvents (vtype, vitem, vid) {
      console.log(vtype, vitem, vid)
    },
    onClickGame (vid) {
      this.nowGame = this.games[parseInt(vid)]
    },
    gameEvents (vtype, vitem) {
      console.log('phone 点击下载：', vtype, vitem)
      if (vtype === 'go_h5') {
        // 附加 url 参数过去（携带渠道参数）
        const urlParam = this.$store.getters.getChannelInfoStr
        tools.openH5Url(vitem.h5Url + urlParam)
      } else if (vtype === 'go_xcx') {
        // 渠道参数
        const miniGameUrl = this.$store.getters.getMiniGameUrl(vitem.downKey)
        tools.openWxMiniGame(miniGameUrl)
      } else {
        // 是否开启 openinstall
        console.log(this.$store.getters.openInstallIsOpen)
        if (this.$store.getters.openInstallIsOpen) {
          if (tools.isIOS()) {
            // ios 先跳 h5 吧（复用按钮点击）
            // this.gameEvents('go_h5', vitem)
            tools.iosDoLocation(this.$store.getters.getDownNow(vitem.downKey))
          } else {
            // openinstall 安装
            tools.openinstallDown(vitem.downKey)
          }
        } else {
          if (tools.isIOS()) {
            // ios 先跳 h5 吧（复用按钮点击）
            // this.gameEvents('go_h5', vitem)
            tools.iosDoLocation(this.$store.getters.getDownNow(vitem.downKey))
          } else {
            tools.iosDoLocation(this.$store.getters.getDownNow(vitem.downKey))
          }
        }
      }
    },
    onClickType (vtype) {
      this.nowType = vtype
    },
    onClickList (vlist) {
      this.nowList = vlist
    }
  },
  computed: {
    allData () {
      return this.$store.state.configs.allGames
    },
    games () {
      if (this.allData[this.nowType].type === 'list') {
        return this.allData[this.nowType].list
      }
      return this.allData[this.nowType].list[this.nowList].list
    },
    gameNum () {
      return this.games.length
    },
    swiperData () {
      return this.$store.state.configs.swiperData
    },
    huodongs () {
      return this.$store.state.configs.huodongs
    },
    news () {
      return this.$store.state.configs.news
    },
    huodongBgStyle () {
      return {
        'background-image': 'url(' + require('@/assets/home_huodong.png') + ')'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btm_16 {
  width: 15%;
  position: fixed;
  bottom: 10%;
  left: 5px;
}
.home_type_ul {
  background: #eaeaea;
  width: 100%;
  height: 3rem;
}
.ul_li_menu {
  position: relative;
  float: left;
  background: #eaeaea;
  font-size: 1.3rem;
  font-weight: bold;
  color: #989898;
}
.ul_li_menu.active {
  background-image: linear-gradient(to right, #42bdff , #1276d1);
  color: #fff;
  border-radius: 6px;
  box-shadow: 0px 3px 6px rgba(0,0,0,0.15);
}
.ul_li_menu_list {
  position: relative;
  float: left;
  padding: 0 1rem;
  border-bottom: 3px #fff solid;
  border-right: 1px #ddd solid;
  color: #989898;
}
.ul_li_menu_list.active {
  border-bottom: 3px #38adf5 solid;
  color: #38adf5;
}
.home_lists_div {
  border-bottom: 1px #aaa solid;
}
.home_types_div li {
  line-height: 3rem;
}
.home_lists_div li {
  line-height: 2rem;
}

.game_but {
  color: rgba(153, 153, 153, 1);
  padding: 0.2rem 0.1rem;
  border-bottom: 0.1rem #fff solid;
}
.game_now {
  color: #37a1ff;
  padding: 0.2rem 0.1rem;
  border-bottom: 0.1rem #37a1ff solid;
}
.gmae_line {
  color: rgba(215, 215, 215, 1);
  font-size: 0.5rem;
  padding: 0 0.5rem;
}
.home_huodong {
  margin-bottom: 1.2rem;
  text-align: left;
  background-repeat: no-repeat;
  background-size: 100% 100%;
      padding-bottom: 2rem;
}
.huodong_title {
  padding: 0.4rem;
  padding-left: 2rem;
  color: #333;
  font-size: 0.9rem;
  border-bottom: 1px rgba(0, 0, 0, 0.04) solid;
  margin-bottom: 0.3rem;
}
.huodong_item {
  padding: 0.4rem;
  padding-left: 2rem;
  font-size: 0.7rem;
}
.huodong_item img {
  width: 0.5rem;
  margin-right: 0.3rem;
}
.huodong_item a {
  color: #666;
  text-decoration: none;
}
</style>
